import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=3558684c&scoped=true"
import script from "./merchant.vue?vue&type=script&lang=ts"
export * from "./merchant.vue?vue&type=script&lang=ts"
import style0 from "./merchant.vue?vue&type=style&index=0&id=3558684c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3558684c",
  null
  
)

export default component.exports